import type { SVGProps } from 'react';

const SvgSpotify = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2m6.42 20.19c-.25.41-.79.54-1.2.29-3.29-2.01-7.43-2.46-12.3-1.35a.864.864 0 0 1-1.04-.66c-.11-.47.19-.94.66-1.04 5.33-1.22 9.91-.69 13.6 1.56.41.25.54.79.29 1.2Zm1.71-3.81a1.1 1.1 0 0 1-1.5.36c-3.76-2.31-9.5-2.98-13.95-1.63a1.09 1.09 0 0 1-1.36-.73c-.17-.58.15-1.19.73-1.36 5.08-1.54 11.41-.8 15.73 1.86.51.32.68.99.36 1.5Zm.15-3.97c-4.51-2.68-11.96-2.93-16.26-1.62a1.307 1.307 0 0 1-.76-2.5c4.95-1.5 13.17-1.21 18.36 1.87a1.307 1.307 0 1 1-1.33 2.25Z"
    />
  </svg>
);

export default SvgSpotify;
